import { usePlatformSettingsModel } from '@src/entities/common';

export const usePlatformSettings = () => {
	const { platformSettings } = usePlatformSettingsModel();

	return { ...platformSettings };
};
